import { createContext, PropsWithChildren, useContext } from 'react';

import merge from 'lodash/merge';

type ChartConfig = {
  isAnimationActive?: boolean | 'auto';
};

const defaultConfig: ChartConfig = {};

const ChartConfigContext = createContext<ChartConfig>(defaultConfig);

type ChartConfigProviderProps = PropsWithChildren<Partial<ChartConfig>>;

export const ChartConfigProvider = ({
  children,
  ...config
}: ChartConfigProviderProps) => {
  return (
    <ChartConfigContext.Provider value={{ ...defaultConfig, ...config }}>
      {children}
    </ChartConfigContext.Provider>
  );
};

export const useChartConfig = (userValues: Partial<ChartConfig> = {}) => {
  const context = useContext(ChartConfigContext);
  return merge({}, context, userValues);
};
